import {
  keepPreviousData,
  useInfiniteQuery,
  useQuery,
} from '@tanstack/react-query'

import { campaignQueries } from '@/entities/campaign'

type Props = {
  page: number
  pageType: 'host' | 'guest'
  categoryId: number | null
}

export const useArticles = ({ page, pageType, categoryId }: Props) => {
  const { data } = useQuery({
    ...campaignQueries.articlesList({
      page,
      onlyGuestArticle: pageType === 'guest',
      onlyHostArticle: pageType === 'host',
      ...(categoryId && { categoryId }),
    }),
    placeholderData: keepPreviousData,
    meta: {
      useCustomHandling: true,
    },
  })

  const articles = data?.articles?.content ?? []
  const lastPage = data?.articles?.lastPage ?? 1
  const articleCategories = data?.articleCategories ?? []

  return {
    lastPage,
    articles,
    articleCategories,
  }
}

export const useArticlesInfiniteQuery = ({
  pageType,
  categoryId,
}: {
  pageType: 'host' | 'guest'
  categoryId: number | null
}) => {
  const result = useInfiniteQuery({
    ...campaignQueries.articlesInfiniteList({
      onlyGuestArticle: pageType === 'guest',
      onlyHostArticle: pageType === 'host',
      ...(categoryId && { categoryId }),
    }),
    enabled: false,
    select: ({ pages }) => {
      return {
        articles: pages.flatMap(({ articles: { content } }) => content),
        articleCategories: pages[0]?.articleCategories ?? [],
        isFirstPage: pages.length === 1,
      }
    },
    placeholderData: keepPreviousData,
  })

  return {
    ...result,
    data: {
      articles: result.data?.articles ?? [],
      articleCategories: result.data?.articleCategories ?? [],
      isFirstPage: result.data?.isFirstPage ?? true,
    },
  }
}
